// extracted by mini-css-extract-plugin
export default {"menu":"menu--NYdcN","scroller":"scroller--_Dq2y"};